import React, { useEffect, useState } from 'react';
import { fetchRecordByKey } from "../../services/IndexedDBUtil";
import { DATABASE_NAME, STORE_NAME } from '../../services/constants'

export default function Report2({ Product, Location }) {

  const[filteredData,setFilteredData] = useState([]);

  useEffect(() => {
    const init = async () => {
       let indexedDBResponse = await fetchRecordByKey(DATABASE_NAME, STORE_NAME, 'WFModelResult');
          if(indexedDBResponse?.success){
            let _data = indexedDBResponse.record?.data
            let skuData = _data.cities.find(cityData => cityData.city === Location)?.data.find(skuData => skuData.sku === Product)?.data;
            setFilteredData(skuData);
          }
    }
    init();

  },[])

  return (
    <div>
       <table className="table dataselectiontable table-bordered">
                                    <thead>
                                        <tr className="bg-blue-900 text-white">
                                            <th className="border border-gray-300 p-2 bg-[#0C3C54] text-white">SKU</th>
                                            <th className="border border-gray-300 p-2 bg-[#0C3C54] text-white">Model</th>
                                            <th className="border border-gray-300 p-2 bg-[#0C3C54] text-white">Param</th>
                                            <th className="border border-gray-300 p-2 bg-[#0C3C54] text-white">Seasonal</th>
                                            <th className="border border-gray-300 p-2 bg-[#0C3C54] text-white">Trend</th>
                                            <th className="border border-gray-300 p-2 bg-[#0C3C54] text-white">Train MAPE</th>
                                            <th className="border border-gray-300 p-2 bg-[#0C3C54] text-white">Test MAPE</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filteredData && filteredData.length > 0 ? (
                                            filteredData.map((row, index) => (
                                                <tr key={index}>
                                                    <td className="border border-gray-200 p-2">{row.sku}</td>
                                                    <td className="border border-gray-200 p-2">{row.model}</td>
                                                    <td className="border border-gray-200 p-2">{row.param}</td>
                                                    <td className="border border-gray-200 p-2">{row.seasonal}</td>
                                                    <td className="border border-gray-200 p-2">{row.trend}</td>
                                                    <td className="border border-gray-200 p-2">{row.train_mape.toFixed(2)}</td>
                                                    <td className="border border-gray-200 p-2">{row.test_mape.toFixed(2)}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="7" className="text-center p-4">
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
    </div>
  )
}
